import { userService } from 'common/services/user.service';
import { Route } from 'common/types/tech';
import React from 'react';

const CompareChatPage = React.lazy(() => import('modules/supermodel/compare-page/compare/compare-chat-page'));
const CompareSettingsPage = React.lazy(() => import('modules/supermodel/settings/compare-settings-page'));
const PlanSelectionPage = React.lazy(() =>
  import('modules/supermodel/settings/plan-selection-page').then(m => ({ default: m.PlanSelectionPage }))
);
// const WelcomePage = React.lazy(() => import('modules/supermodel/compare-page/welcome-container'));
const AboutPage = React.lazy(() =>
  import('modules/supermodel/compare-page/welcome/about-page').then(m => ({ default: m.AboutPage }))
);
const PrivacyPage = React.lazy(() =>
  import('modules/supermodel/compare-page/welcome/privacy-page').then(m => ({ default: m.PrivacyPage }))
);
const TermsPage = React.lazy(() =>
  import('modules/supermodel/compare-page/welcome/terms-page').then(m => ({ default: m.TermsPage }))
);
const NotFoundPage = React.lazy(() =>
  import('modules/supermodel/compare-page/welcome/not-found-page').then(m => ({ default: m.NotFoundPage }))
);
const SharedAlbumPage = React.lazy(() =>
  import('modules/supermodel/shared-album').then(m => ({ default: m.SharedAlbumPage }))
);
const PrintEditorPage = React.lazy(() =>
  import('modules/supermodel/print-page/print-page').then(m => ({ default: m.PrintPage }))
);
const EditVariationsPage = React.lazy(() =>
  import('modules/supermodel/print-page/edit-admin-variations').then(m => ({ default: m.EditAdminVariations }))
);
const ShopifyProductsPage = React.lazy(() =>
  import('modules/supermodel/shopify-products-page/shopify-products-page').then(m => ({
    default: m.ShopifyProductsPage,
  }))
);
const PrintifyProductsPage = React.lazy(() =>
  import('modules/supermodel/printify-products-page/printify-products-page').then(m => ({
    default: m.PrintifyProductsPage,
  }))
);
const DashboardPage = React.lazy(() =>
  import('modules/supermodel/dashboard-page/dashboard-page').then(m => ({
    default: m.DashboardPage,
  }))
);
const AlbumsPage = React.lazy(() =>
  import('modules/supermodel/albums-page/albums-page').then(m => ({
    default: m.AlbumsPage,
  }))
);
const CreatePage = React.lazy(() =>
  import('modules/supermodel/create-page/create-page').then(m => ({
    default: m.CreatePage,
  }))
);
const ChatPage = React.lazy(() =>
  import('modules/supermodel/chat-page/chat-page').then(m => ({
    default: m.ChatPage,
  }))
);

export const getSupermodelRoutes = (): Array<Route> => [
  {
    path: '/',
    preview: 'Home',
    component: DashboardPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/about',
    preview: 'About',
    component: AboutPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/privacy',
    preview: 'Privacy Policy',
    component: PrivacyPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/terms',
    preview: 'Terms of Service',
    component: TermsPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/albums/:pipeline_id',
    preview: 'Album',
    component: CompareChatPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/shared/album/:rule_id',
    preview: 'Shared Album',
    component: SharedAlbumPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/settings',
    preview: 'Home',
    component: CompareSettingsPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/settings/plans',
    preview: 'Plans',
    component: PlanSelectionPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '*',
    preview: 'Not Found',
    component: NotFoundPage,
    checkAvailability: () => true,
    protected: false,
    keepUnauthenticated: true,
    hiddenLayout: true,
  },
  {
    path: '/print',
    preview: 'Print Editor',
    component: PrintEditorPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/edit-variations',
    preview: 'Edit Variations',
    component: EditVariationsPage,
    checkAvailability: () => userService.isAdmin(),
    protected: true,
  },
  {
    path: '/shopify-products',
    preview: 'Shopify Products',
    component: ShopifyProductsPage,
    checkAvailability: () => true,
    protected: userService.isAdmin(),
  },
  {
    path: '/printify-products',
    preview: 'Printify Products',
    component: PrintifyProductsPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/albums',
    preview: 'Albums',
    component: AlbumsPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/create',
    preview: 'Create',
    component: CreatePage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/chat',
    preview: 'Chat',
    component: ChatPage,
    checkAvailability: () => true,
    protected: true,
  },
];
